<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import { mapGetters } from 'vuex'
import { Helper } from '@/mixin/helper'
/**
 * Starter component
 */
export default {
  page: {
    title: 'Manajemen Whitelabel',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  mixins: [Helper],
  data() {
    return {
      phaseOneShow: false,
    }
  },

  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
    }),
    title() {
      return this.$t('setting.homePage.whitelabel')
    },
  },
}
</script>

<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" />
      <p class="mb-4">{{ $t('setting.homePage.textWhitelabel') }}</p>
      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <b-button
            @click="$router.push({ name: 'Setting' })"
            variant="outline-primary"
            class="ms-3"
          >
            <i class="mc-fa icon-outline_arrow-left"></i>
            {{ $t('global.back') }}
          </b-button>
        </div>
      </div>
    </div>

    <div class="card mc-card mc-card-front">
      <div class="card-body">
        <b-row class="mc-card__list">
          <b-col sm="12" md="12" v-if="hasAccess(['c13b-default-color:read'])">
            <b-button
              variant="outline-light"
              @click="$router.push({ name: 'Management Color' })"
              class="d-block w-100 mc-card__list-item clearfix"
            >
              <div class="mc-card__list-item-content ps-0">
                <h4>{{ $t('setting.list.managementAsset.color.title') }}</h4>
                <p>{{ $t('setting.list.managementAsset.color.subtitle') }}</p>
              </div>
              <i class="mc-fa-right icon-fill_arrow-ios-right"></i>
            </b-button>
          </b-col>

          <b-col sm="12" md="12" v-if="hasAccess(['c13a-default-logo:read'])">
            <b-button
              variant="outline-light"
              @click="$router.push({ name: 'Management Logo' })"
              class="d-block w-100 mc-card__list-item clearfix"
            >
              <div class="mc-card__list-item-content ps-0">
                <h4>{{ $t('setting.list.managementAsset.logo.title') }}</h4>
                <p>{{ $t('setting.list.managementAsset.logo.subtitle') }}</p>
              </div>
              <i class="mc-fa-right icon-fill_arrow-ios-right"></i>
            </b-button>
          </b-col>

          <b-col sm="12" md="12" v-if="hasAccess(['c13c-default-banner:read'])">
            <b-button
              variant="outline-light"
              @click="$router.push({ name: 'Management Banner' })"
              class="d-block w-100 mc-card__list-item clearfix"
            >
              <div class="mc-card__list-item-content ps-0">
                <h4>{{ $t('setting.list.managementAsset.banner.title') }}</h4>
                <p>{{ $t('setting.list.managementAsset.banner.subtitle') }}</p>
              </div>
              <i class="mc-fa-right icon-fill_arrow-ios-right"></i>
            </b-button>
          </b-col>

          <b-col sm="12" md="12" v-if="hasAccess(['c13d-default-contact:read'])">
            <b-button
              variant="outline-light"
              @click="$router.push({ name: 'Company Contact' })"
              class="d-block w-100 mc-card__list-item clearfix"
            >
              <div class="mc-card__list-item-content ps-0">
                <h4>{{ $t('setting.list.managementAsset.companyContact.title') }}</h4>
                <p>{{ $t('setting.list.managementAsset.companyContact.subtitle') }}</p>
              </div>
              <i class="mc-fa-right icon-fill_arrow-ios-right"></i>
            </b-button>
          </b-col>
        </b-row>
      </div>
    </div>
  </Layout>
</template>
